export default __webpack_public_path__ + "static/media/img_baseCrochet_green_p.8f9a383b.jpg";